import type { Swapper } from '../../types'
import { executeTronTransaction } from '../../utils'

export const sunioSwapper: Swapper = {
  executeTronTransaction,
}
